import React from 'react';
import '../CSS/QuemsomosAboutus.css';
import backgroundImage from '../Images/fundo2.png';
import backgroundImageWebp from '../Images/fundo2.webp';

const Politicas = () => {
  return (
    <div>
      <picture>
        <source srcSet={backgroundImageWebp} type="image/webp" />
        <img src={backgroundImage} className="backImage2" alt="" loading="eager" decoding="async" />
      </picture>

      <div className="er-pageShell">
        <div className="divCenteredContent er-container">
          <div className="divBigTitle">
            <h1 className="BigTitle">Política de Cookies</h1>
          </div>

          <p className="regularTextYellow">1. O que são Cookies</p>
          <p className="regularText">
            Cookies são pequenos ficheiros de texto armazenados no dispositivo do utilizador quando visita um website. Estes permitem
            melhorar a experiência de navegação e recolher informações estatísticas.
          </p>

          <p className="regularTextYellow">2. Tipos de Cookies Utilizados</p>
          <p className="regularText">O website pode utilizar os seguintes tipos de cookies:</p>

          <p className="regularTextYellow">- Cookies Estritamente Necessários</p>
          <p className="regularText">
            Essenciais para o funcionamento do website e para permitir funcionalidades básicas, como navegação e acesso a áreas seguras.
          </p>
          <p className="regularText">Estes cookies não requerem consentimento.</p>

          <p className="regularTextYellow">- Cookies de Análise / Estatísticos</p>
          <p className="regularText">
            Utilizados para recolher informações estatísticas de forma agregada e anónima, permitindo analisar a utilização do website e
            melhorar os serviços.
          </p>
          <p className="regularText">Estes cookies só são utilizados mediante consentimento do utilizador.</p>

          <p className="regularTextYellow">3. Gestão de Cookies</p>
          <p className="regularText">O utilizador pode, a qualquer momento:</p>
          <p className="regularText">- Aceitar ou recusar cookies não essenciais através do banner de cookies</p>
          <p className="regularText">- Configurar o seu navegador para bloquear ou eliminar cookies</p>
          <p className="regularText">A desativação de cookies pode afetar algumas funcionalidades do website.</p>

          <p className="regularTextYellow">4. Cookies de Terceiros</p>
          <p className="regularText">
            O website poderá utilizar serviços de terceiros para fins estatísticos (por exemplo, ferramentas de análise). Estes terceiros
            tratam os dados de acordo com as suas próprias políticas de privacidade.
          </p>

          <p className="regularTextYellow">5. Alterações à Política de Cookies</p>
          <p className="regularText">
            Esta Política de Cookies pode ser atualizada a qualquer momento. Quaisquer alterações serão publicadas no website.
          </p>

          <p className="regularTextYellow">6. Contactos</p>
          <p className="regularText">
            Para mais informações sobre a utilização de cookies, poderá contactar-nos através de:{" "}
            <a className="regularText" href="mailto:be.escaperoom@gmail.com">be.escaperoom@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Politicas;
